module.exports = __webpack_public_path__ + "img/icon_Room-Service.ac3c60b2.svg";